import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import "../../Assets/css/footer.css";
import { NavLink, useHistory } from "react-router-dom";
import WholeSale from "../../Assets/images/DFL/Wholesale.webp";
import { base_url, isLogin } from "../../Helpers/request";
import axios from "axios";
import { LazyLoadImage } from "react-lazy-load-image-component";
import {
  FaFacebook,
  FaInstagram,
  FaInstagramSquare,
  FaPinterest,
  FaTwitter,
  FaYelp,
} from "react-icons/fa";
const Footer = () => {
  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("dfl-session-id")?.length || isLogin) {
      console.log("session exist!");
    } else {
      axios
        .get(base_url + "/home/getsessionid")
        .then((res) => {
          if (res.data.status == 1) {
            localStorage.setItem("dfl-session-id", res.data.data?.session_id);
          } else {
            console.log("sessionid not generated");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, []);

  return (
    <>
      <footer id="footer">
        <div className="footer2 ftpd">
          <div className="container-fluid">
            <div className="main-footer2">
              <Row className="frowbg ">
                <Col lg={6} md={12} className="fbgimg">
                  <div className="lftfooter">
                    <div className="block-footer2 abtfooter">
                      <h2
                        className="title20 dark foot-w btfoot"
                        onClick={() => history.push("/about-diamonds-for-less")}
                      >
                        About Us
                      </h2>
                      <p className="foot-w">
                        Diamonds For Less Is 3 rd Generation Family Owned &
                        Operated Business. Toronto’s Source For Wholesale Priced
                        Engagement Rings & Diamond Jewellery.
                        <NavLink
                          className="foot_rmore foot-w"
                          to="/about-diamonds-for-less"
                        >
                          {" "}
                          Read More
                        </NavLink>
                      </p>
                    </div>
                    <div className="block-footer2">
                      <h2 className="title20 dark foot-w btfoot">
                        Follow Us On
                      </h2>
                      <div className="social-network-footer ">
                        <a
                          rel="noreferrer"
                          href="https://www.facebook.com/pg/DiamondsForLess/reviews"
                          target="_blank"
                          className="inline-block round"
                        >
                          <FaFacebook />
                        </a>
                        <a
                          rel="noreferrer"
                          href="https://twitter.com/diamondsforless"
                          target="_blank"
                          className="inline-block round"
                        >
                          <FaTwitter />
                        </a>
                        <a
                          rel="noreferrer"
                          href="https://www.instagram.com/dfltoronto/?igshid=YmMyMTA2M2Y%3D"
                          target="_blank"
                          className="inline-block round"
                        >
                          <FaInstagram />
                        </a>
                        <a
                          rel="noreferrer"
                          href="https://in.pinterest.com/diamondforless/"
                          target="_blank"
                          className="inline-block round"
                        >
                          <FaPinterest />
                        </a>
                        <a
                          rel="noreferrer"
                          href="https://www.yelp.ca/biz/diamonds-for-less-toronto"
                          target="_blank"
                          className="inline-block round "
                        >
                          <FaYelp />
                        </a>{" "}
                      </div>
                    </div>
                  </div>
                </Col>
                <Col lg={6} md={12} className="">
                  <div className="rightfooter dfl_footer_links">
                    <Row className="justify-content-center">
                      <Col xs={12} sm={4} md={4} lg={4}>
                        <div className="block-footer2">
                          <h2 className="title20 dark">Get in Touch</h2>

                          <ul className="list-none contact-foter2">
                            <li>
                              <NavLink
                                to="#"
                                target="_blank"
                                onClick={() => {
                                  window.open(
                                    "https://www.google.com/maps/dir/5+Shuter+St,+Toronto,+ON+M5B+2H8,+Canada/@43.6540529,-79.4494563,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x89d4cb34a5006187:0x7d775a6a5641f2d!2m2!1d-79.3794165!2d43.6540743",
                                    "_blank"
                                  );
                                }}
                              >
                                <i className="fa fa-map-marker dark" />
                                <span className="dark">
                                  5 Shuter St, Toronto,
                                  <br />
                                  ON M5B 2H8, Canada
                                </span>
                              </NavLink>
                            </li>
                            <li>
                              <i className="fa fa-volume-control-phone dark" />
                              <a href="tel:+1 416 362 9944">+1 (416)362-9944</a>
                            </li>
                            <li>
                              <i className="fa fa-envelope dark" />
                              <NavLink
                                className="dark"
                                to="#"
                                target="_blank"
                                onClick={(e) => {
                                  window.location.href = `mailto:info@diamondsforless.ca`;
                                }}
                              >
                                info@diamondsforless.ca
                              </NavLink>
                            </li>
                          </ul>
                        </div>
                      </Col>
                      <Col xs={12} sm={4} lg={4} className="col-md-4 clrbt">
                        <div className="block-footer3">
                          <h2 className="title20 dark">
                            Help &amp; Infomation
                          </h2>
                          <ul className="list-none contact-foter2">
                            {/* <li><NavLink to="https://marblecaves.demobw.com/contact" className="dark ">Contact Us</NavLink></li> */}
                            <li>
                              <NavLink to="/" className="dark">
                                Cookies &amp; Policy
                              </NavLink>
                            </li>
                            <li>
                              <NavLink to="/privacy-policy" className="dark ">
                                Privacy Policy
                              </NavLink>
                            </li>
                            <li>
                              <NavLink to="/terms-conditions" className="dark">
                                Terms &amp; Conditions
                              </NavLink>
                            </li>
                            <li>
                              <NavLink to="/warranty" className="dark">
                                Warranty
                              </NavLink>
                            </li>
                          </ul>
                        </div>
                      </Col>
                      <Col xs={12} sm={4} lg={4}>
                        <div className="block-footer3">
                          <h2 className="title20 dark">Info</h2>
                          <ul className="list-none contact-foter2">
                            <li>
                              <NavLink
                                to="/about-diamonds-for-less"
                                className="dark"
                              >
                                About Us
                              </NavLink>
                            </li>
                            <li>
                              <NavLink to="/contact-us" className="dark ">
                                Contact Us
                              </NavLink>
                            </li>
                            <li>
                              <NavLink to="/education" className="dark ">
                                Education
                              </NavLink>
                            </li>
                            <li>
                              <NavLink to="#" className="dark ">
                                Our Contributions
                              </NavLink>
                            </li>
                            <li>
                              <NavLink to="/blog" className="dark ">
                                Blog
                              </NavLink>
                            </li>
                          </ul>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
        <div className="bottom-bar">
          <p className="desc copyright-footer text-center mb-1">
            <span className="dark opaci ">
              Diamonds For Less © {new Date().getFullYear()} All Rights
              Reserved. Designed and Developed by:
            </span>{" "}
            <NavLink to="/" target="_blank">
              Belgium Webnet
            </NavLink>
          </p>
        </div>
      </footer>

      <div className="newsletter-toolbar d-none d-xl-block d-lg-block">
        <div className="toolbar--social">
          <div className="icon-social">
            <ul className="social-icons">
              <li className="facebook">
                <a rel="noreferrer"
                  href="https://www.facebook.com/pg/DiamondsForLess/reviews"
                  title="Facebook"
                  target="_blank"
                >
                  {/* <i className="fa fa-facebook fa-xl" aria-hidden="true" /> */}
                  <FaFacebook className="fa-xl"/>
                </a>
              </li>
              <li className="twitter">
                <a rel="noreferrer"
                  href="https://twitter.com/diamondsforless"
                  title="Twitter"
                  target="_blank"
                >
                  {/* <i className="fa fa-twitter fa-xl" aria-hidden="true" /> */}
                  <FaTwitter className="fa-xl"/>
                </a>
              </li>
              <li className="instagram">
                <a rel="noreferrer"
                  href="https://www.instagram.com/dfltoronto/?igshid=YmMyMTA2M2Y%3D"
                  title="Instagram"
                  target="_blank"
                >
                  {/* <i className="fa fa-instagram fa-xl" aria-hidden="true" /> */}
                  <FaInstagram className="fa-xl"/>
                </a>
              </li>
              <li className="whatsapp">
                <a rel="noreferrer"
                  href="https://in.pinterest.com/diamondforless/"
                  target="_blank"
                  className="inline-block round"
                >
                  {/* <i className="fa fa fa-pinterest" /> */}
                  <FaPinterest className="fa-xl"/>
                </a>
              </li>
              <li className="whatsapp">
                <a rel="noreferrer"
                  className=""
                  href="https://www.yelp.ca/biz/diamonds-for-less-toronto"
                  target="_blank"
                  title="yelp"
                >
                  {/* <i className="fa fa-yelp fa-xl" aria-hidden="true"></i> */}
                  <FaYelp className="fa-xl"/>
                </a>
              </li>
            </ul>
          </div>
        </div>
        {/* <div className="toolbar--text">
          <span data-modal-newsletter className="newsletter-toolbar_popup">Newsletter</span>
        </div> */}
      </div>

      <div className="dfl_wholesale">
        <LazyLoadImage src={WholeSale} alt="whole sale" />
      </div>
    </>
  );
};
export default React.memo(Footer);
